module.exports = __webpack_public_path__ + "static/media/emptyimage.231650ac.svg";